// ฟอร์มสมัครสมาชิกแบบ popup (สร้างใหม่เฉพาะหน้าแรก) — ไม่ใช่หน้า /register
// ใช้ API เดียวกับหน้าสมัครจริง: resetpassword(type6 เช็คเบอร์), register, userlogin
import React, { useEffect, useState } from 'react';
import instance from './axios-instance';
import Systems from './SystemFunction';
import Swal from 'sweetalert2';
import { t } from './site/i18n';

// รายชื่อธนาคารสำรอง (ใช้เมื่อโหลดจาก API ไม่ได้) — ชื่อ + id ตรงกับระบบ
const FALLBACK_BANKS = [
  { id: 99, name: 'ทรูวอลเลท' },
  { id: 5, name: 'ไทยพาณิชย์' },
  { id: 6, name: 'กสิกรไทย' },
  { id: 7, name: 'กรุงเทพ' },
  { id: 8, name: 'กรุงศรีอยุธยา' },
  { id: 9, name: 'เกียรตินาคิน' },
  { id: 11, name: 'ทหารไทยธนชาต' },
  { id: 12, name: 'ธนชาต' },
  { id: 14, name: 'กรุงไทย' },
  { id: 15, name: 'ออมสิน' },
  { id: 16, name: 'ธ.ก.ส.' },
  { id: 53, name: 'อาคารสงเคราะห์' },
];

export default function RegisterForm({ onClose }) {
  const [phone, setPhone] = useState('');
  const [bankid, setBankid] = useState(0);
  const [accno, setAccno] = useState('');
  const [fname, setFname] = useState('');
  const [password, setPassword] = useState('');
  const [passwordcf, setPasswordcf] = useState('');
  const [referrer, setReferrer] = useState('');
  const [banks, setBanks] = useState(FALLBACK_BANKS);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  // โหลดรายชื่อธนาคารจริงจาก API (tblbank) — ชื่อถูกต้องตามที่เว็บเปิดใช้
  useEffect(() => {
    instance.post('/api/v1/mainsetting', { System: Systems })
      .then((res) => {
        const d = res && res.data ? res.data : {};
        const bl = d.tblbank || (d.data && d.data.tblbank) || (d.message && d.message.tblbank) || [];
        const list = (Array.isArray(bl) ? bl : [])
          .filter((b) => b && (b.fullname_th || b.acro))
          .map((b) => ({ id: Number(b.bank_id), name: b.fullname_th || b.acro }));
        if (list.length) setBanks(list);
      })
      .catch(() => { /* ใช้ FALLBACK_BANKS */ });
  }, []);

  // ดึงผู้แนะนำ (affiliate) จากลิงก์ชวนเพื่อน — ยังเก็บเงียบ ๆ ไม่โชว์ช่องให้กรอก
  useEffect(() => {
    try {
      const href = window.location.href;
      const byReg = (href.split('reg=')[1] || '').split('&')[0];
      if (byReg) { setReferrer(byReg); return; }
      const aff = localStorage.getItem('aff') || localStorage.getItem('register');
      if (aff) { const o = JSON.parse(aff); if (o && o.username) setReferrer(o.username); }
    } catch (e) { /* ignore */ }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (!/^[0-9]{10}$/.test(phone)) { setErr(t('common.wrong_phone')); return; }
    if (bankid === 0) { setErr(t('common.no_bank_selected')); return; }
    if (!accno.trim()) { setErr(t('common.missing_account_no')); return; }
    if (!fname.trim()) { setErr(t('common.missing_name')); return; }
    if (!password) { setErr(t('common.password')); return; }
    if (password !== passwordcf) { setErr(t('common.password_mismatch')); return; }

    setLoading(true);
    try {
      // เช็คเบอร์ว่าใช้ได้ไหม (type 6)
      const chk = await instance.post('/api/v1/resetpassword', { username: phone, System: Systems, type: 6 });
      const msg = chk && chk.data && chk.data.message;
      if (msg && msg.checked === false) {
        setLoading(false);
        setErr(msg.status === 201 ? t('common.phone_in_use') : t('common.too_frequent'));
        return;
      }

      // สมัคร — ใช้ชื่อที่ลูกค้ากรอกเองตรง ๆ (ไม่ verify เลขบัญชี)
      const res = await instance.post('/api/v1/register', {
        User_id: phone,
        name: fname.trim(),
        password: password,
        accbank: bankid,
        accno: accno,
        System: Systems,
        Useradvise: referrer,
      });

      if (res.data.status === 200) {
        // ล็อกอินอัตโนมัติทันทีหลังสมัคร (ไม่ต้องรอผู้ใช้กดปุ่ม)
        try {
          const lg = await instance.post('/api/v1/userlogin', {
            userid: phone, password: password, System: Systems, Function: 'RegisterForm.js',
          });
          if (lg.status === 200 && lg.data.status === 200 && lg.data.token) {
            localStorage.setItem('auth_token', lg.data.token);
          }
        } catch (eLogin) { /* ignore */ }
        // แจ้งสำเร็จแบบไม่บล็อก (ปิดเอง) แล้วเข้าเว็บทันที
        Swal.fire({ title: t('common.success'), text: t('register.success'), icon: 'success', timer: 1400, timerProgressBar: true, showConfirmButton: false });
        setTimeout(() => { window.location.href = '/'; }, 1400);
        return;
      } else if (res.data.status === 202) {
        setErr(t('common.username_taken'));
      } else {
        setErr(t('common.invalid_register_name'));
      }
    } catch (e2) {
      setErr(t('common.invalid_register_name'));
    }
    setLoading(false);
  };

  return (
    <form className="rp-form" onSubmit={submit}>
      <h3 className="rp-title">{t('register.title')}</h3>

      <label className="rp-label">{t('common.phone')}</label>
      <input className="rp-input" type="tel" inputMode="numeric" maxLength={10} value={phone}
        onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ''))} placeholder={t('common.phone')} autoFocus />

      <label className="rp-label">{t('register.bank') || 'ธนาคาร'}</label>
      <select className="rp-input rp-bank-select" value={bankid}
        onChange={(e) => setBankid(Number(e.target.value))}>
        <option value={0}>-- เลือกธนาคาร --</option>
        {banks.map((b) => (
          <option key={b.id} value={b.id}>{b.name}</option>
        ))}
      </select>

      <label className="rp-label">{t('register.account_number')}</label>
      <input className="rp-input" type="text" inputMode="numeric" value={accno}
        onChange={(e) => setAccno(e.target.value.replace(/[^0-9]/g, ''))} placeholder={t('register.account_placeholder')} />

      <label className="rp-label">{t('register.fullname_placeholder') || 'ชื่อ-นามสกุล'}</label>
      <input className="rp-input" type="text" value={fname} onChange={(e) => setFname(e.target.value)}
        placeholder={t('register.fullname_placeholder') || 'ชื่อ-นามสกุล'} />

      <label className="rp-label">{t('common.password')}</label>
      <input className="rp-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
        placeholder={t('common.password')} />

      <label className="rp-label">{t('register.confirm_password')}</label>
      <input className="rp-input" type="password" value={passwordcf} onChange={(e) => setPasswordcf(e.target.value)}
        placeholder={t('register.confirm_password')} />

      {err ? <div className="rp-error">{err}</div> : null}

      <button type="submit" className="rp-submit" disabled={loading}>
        {loading ? '...' : t('common.register_now')}
      </button>
    </form>
  );
}
